module.exports = __webpack_public_path__ + "media/icons/guardant360-7bc0bbac.svg";